import { render, staticRenderFns } from "./PointSelect.vue?vue&type=template&id=6daf5975&scoped=true&"
import script from "./PointSelect.vue?vue&type=script&lang=js&"
export * from "./PointSelect.vue?vue&type=script&lang=js&"
import style0 from "./PointSelect.vue?vue&type=style&index=0&id=6daf5975&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daf5975",
  null
  
)

export default component.exports